// Shared renderer for custom Entry Pass templates.
// Renders at an explicit pixel width so preview and export stay pixel-identical.

export const SAMPLE_PHOTO =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><rect width='160' height='160' fill='#e2e8f0'/><text x='80' y='86' font-size='18' fill='#94a3b8' text-anchor='middle' font-family='sans-serif'>PHOTO</text></svg>"
  );

export function resolveText(el, ctx) {
  if (el.bind === "__serial") { const p = ctx.serial_prefix || "SR. "; return ctx.serial_no ? p + String(ctx.serial_no).padStart(3, "0") : p + "001"; }
  if (el.bind === "__name") return ctx.candidate_name || "Candidate Name";
  if (el.bind === "__event") return ctx.event_name || "Event";
  const v = ctx.data?.[el.bind];
  return (v === undefined || v === null || v === "") ? (el.label || "") : String(v);
}

export function resolveImage(el, ctx) {
  if (el.kind === "qr") return ctx.qrDataUrl || "";
  return ctx.data?.[el.bind] || "";
}

export function PassTemplateView({ template, ctx, widthPx }) {
  const w = Number(template.width) || 100;
  const h = Number(template.height) || 100;
  const heightPx = Math.round(widthPx * (h / w));
  return (
    <div
      style={{ position: "relative", width: widthPx, height: heightPx, overflow: "hidden", background: "#fff" }}
      data-testid="pass-template-view"
    >
      {template.image && (
        <img src={template.image} alt="" crossOrigin="anonymous" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
      )}
      {(template.elements || []).map((el) => {
        const left = (el.x / 100) * widthPx;
        const top = (el.y / 100) * heightPx;
        if (el.kind === "qr" || el.kind === "image") {
          const val = resolveImage(el, ctx);
          if (!val) return null;
          const s = (el.size / 100) * widthPx;
          return (
            <img
              key={el.id}
              src={val}
              alt=""
              crossOrigin="anonymous"
              style={{ position: "absolute", left, top, width: s, height: s, transform: "translate(-50%,-50%)", objectFit: "cover" }}
            />
          );
        }
        const fontPx = (el.size / 100) * widthPx;
        return (
          <div
            key={el.id}
            style={{
              position: "absolute",
              left,
              top,
              transform: "translate(-50%,-50%)",
              fontSize: fontPx,
              color: el.color || "#111111",
              fontWeight: el.weight || "700",
              textAlign: el.align || "center",
              whiteSpace: "nowrap",
              lineHeight: 1.1,
              fontFamily: "sans-serif",
            }}
          >
            {resolveText(el, ctx)}
          </div>
        );
      })}
      {ctx?.tag && (
        <div data-testid="pass-tag" style={{ position: "absolute", top: 0, right: 0, background: "#fbbf24", color: "#451a03", fontWeight: 800, fontSize: Math.round(widthPx * 0.035), padding: `${Math.round(widthPx * 0.008)}px ${Math.round(widthPx * 0.02)}px`, borderBottomLeftRadius: Math.round(widthPx * 0.015), letterSpacing: "0.05em", fontFamily: "sans-serif", zIndex: 2 }}>
          {ctx.tag}
        </div>
      )}
    </div>
  );
}
